import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// A regenerated aws-exports.js can rename an aws_cloud_logic_custom entry to
// the raw API Gateway id, breaking every `get({ apiName: '...' })` lookup
// (this took down Drift's API on 2026-08-01). Restore the friendly name from
// the stable API Gateway id in the endpoint URL before configuring Amplify.
const restApis = awsExports.aws_cloud_logic_custom || [];
if (!restApis.some((c) => c.name === 'wolftechAdminApi')) {
  const admin = restApis.find((c) => c.endpoint?.includes('lr33r9hx1j'));
  if (admin) admin.name = 'wolftechAdminApi';
}
Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
